import IMG_SLIDER_LEFT_WHITE_PC from 'assets/images/scooter/evc1/ev_c1_slider_left_pc_white.png'
import IMG_SLIDER_LEFT_WHITE_PAD from 'assets/images/scooter/evc1/ev_c1_slider_left_pad_white.png'
import IMG_SLIDER_LEFT_WHITE_MOBILE from 'assets/images/scooter/evc1/ev_c1_slider_left_mobile_white.png'

import IMG_SLIDER_RIGHT_WHITE_PC from 'assets/images/scooter/evc1/ev_c1_slider_right_pc_white.png'
import IMG_SLIDER_RIGHT_WHITE_PAD from 'assets/images/scooter/evc1/ev_c1_slider_right_pad_white.png'
import IMG_SLIDER_RIGHT_WHITE_MOBILE from 'assets/images/scooter/evc1/ev_c1_slider_right_mobile_white.png'

import IMG_SLIDER_LEFT_BLACK_PC from 'assets/images/scooter/evc1/ev_c1_slider_left_pc_black.png'
import IMG_SLIDER_LEFT_BLACK_PAD from 'assets/images/scooter/evc1/ev_c1_slider_left_pad_black.png'
import IMG_SLIDER_LEFT_BLACK_MOBILE from 'assets/images/scooter/evc1/ev_c1_slider_left_mobile_black.png'

import IMG_SLIDER_RIGHT_BLACK_PC from 'assets/images/scooter/evc1/ev_c1_slider_right_pc_black.png'
import IMG_SLIDER_RIGHT_BLACK_PAD from 'assets/images/scooter/evc1/ev_c1_slider_right_pad_black.png'
import IMG_SLIDER_RIGHT_BLACK_MOBILE from 'assets/images/scooter/evc1/ev_c1_slider_right_mobile_black.png'

import IMG_1_1 from 'assets/images/scooter/evc1/evc1_one_image_pc.png'
import IMG_1_2 from 'assets/images/scooter/evc1/evc1_one_image_pad.png'
import IMG_1_3 from 'assets/images/scooter/evc1/evc1_one_image_mobile.png'

import IMG_2_1 from 'assets/images/scooter/evc1/evc1_two_image_pc.png'
import IMG_2_2 from 'assets/images/scooter/evc1/evc1_two_image_pad.png'
import IMG_2_3 from 'assets/images/scooter/evc1/evc1_two_image_mobile.png'

import IMG_3_1 from 'assets/images/scooter/evc1/evc1_three_image_pc.png'
import IMG_3_2 from 'assets/images/scooter/evc1/evc1_three_image_pad.png'
import IMG_3_3 from 'assets/images/scooter/evc1/evc1_three_image_mobile.png'

import IMG_6_1 from 'assets/images/scooter/evc1/evc1_six_image_pc.png'
import IMG_6_2 from 'assets/images/scooter/evc1/evc1_six_image_pad.png'
import IMG_6_3 from 'assets/images/scooter/evc1/evc1_six_image_mobile.png'

import IMG_7_1 from 'assets/images/scooter/evc1/evc1_seven_image_pc.png'
import IMG_7_2 from 'assets/images/scooter/evc1/evc1_seven_image_pad.png'
import IMG_7_3 from 'assets/images/scooter/evc1/evc1_seven_image_mobile.png'

import IMG_9_1 from 'assets/images/scooter/evc1/evc1_nine_image_pc.png'
import IMG_9_2 from 'assets/images/scooter/evc1/evc1_nine_image_pad.png'
import IMG_9_3 from 'assets/images/scooter/evc1/evc1_nine_image_mobile.png'

import IMG_10 from 'assets/images/scooter/evc1/EVC1_belt_detail_mobile.jpg'
import IMG_10_1 from 'assets/images/scooter/evc1/EVC1_belt_detail_pc.jpg'

import ScooterEvC1SwiperOne from '../../components/swiper/ScooterEvC1SwiperOne'
import ScooterEvC1SwiperTwo from '../../components/swiper/ScooterEvC1SwiperTwo'
import ScooterEvC1SwiperThree from '../../components/swiper/ScooterEvC1SwiperThree'
import ScooterEvC1SwiperFour from '../../components/swiper/ScooterEvC1SwiperFour'
import ScooterEvC1SwiperFive from '../../components/swiper/ScooterEvC1SwiperFive'

import { EVC1_SCOOTER_INFO } from '../../assets/json/scooterInfo.js'

import './ScooterEvC1.scss'

/**
 * @file EV-C1 화면
 */
function ScooterEvC1() {
    return (
        <div className="ev_c1_page">
            {/* <div className="ev_c1_container">
            </div> */}
            <img className="evc1_belt_pc" src={IMG_10_1} alt="라이더를 위해 태어난 한국형 전기스쿠터 EVC1" />
            <img className="evc1_belt_mobile" src={IMG_10} alt="라이더를 위해 태어난 한국형 전기스쿠터 EVC1" />

            <div className="evc1_one">
                <img className="evc1_one_image_pc" src={IMG_1_1} alt="라이더를 위해 태어난 한국형 전기스쿠터 EVC1" />
                <img className="evc1_one_image_pad" src={IMG_1_2} alt="라이더를 위해 태어난 한국형 전기스쿠터 EVC1" />
                <img
                    className="evc1_one_image_mobile"
                    src={IMG_1_3}
                    alt="라이더를 위해 태어난 한국형 전기스쿠터 EVC1"
                />
                {/* <div className="evc1_one_t1">라이더를 위해 태어난 한국형 전기스쿠터</div> */}
            </div>
            <div className="evc1_two">
                <img className="evc1_two_image_pc" src={IMG_2_1} alt="가장 완벽한 전기 스쿠터의 탄생" />
                <img className="evc1_two_image_pad" src={IMG_2_2} alt="가장 완벽한 전기 스쿠터의 탄생" />
                <img className="evc1_two_image_mobile" src={IMG_2_3} alt="가장 완벽한 전기 스쿠터의 탄생" />
                <div className="evc1_two_t_wrap">
                    <div className="evc1_two_t1">
                        가장 완벽한
                        <br />
                        전기스쿠터의 탄생
                    </div>
                    <div className="evc1_two_t2">
                        새롭게 진화된 고성능 전기스쿠터 EV-C1
                        <br />
                        날렵한 디자인과 여태껏 경험하지 못한 상상 이상의
                        <br />
                        강렬한 퍼포먼스로 특별한 라이딩을 제공합니다.
                    </div>
                </div>
                <div className="evc1_two_info_t_wrapper">
                    <div className="evc1_two_info_t_wrap">
                        <div className="evc1_two_info_t1">최대 출력</div>
                        <div className="evc1_two_info_t1_val_wrap">
                            <div className="evc1_two_info_t1_val">7.2</div>
                            <div className="evc1_two_info_t1_unit_1">kW&nbsp;</div>
                            <div className="evc1_two_info_t1_unit_2">@3,000rpm</div>
                        </div>
                    </div>

                    <div className="evc1_two_info_t_wrap">
                        <div className="evc1_two_info_t1">최대 가속</div>
                        <div className="evc1_two_info_t1_val_wrap">
                            <div className="evc1_two_info_t1_val">3.8</div>
                            <div className="evc1_two_info_t1_unit_1">SEC</div>
                            <div className="evc1_two_info_t1_unit_2 mobile">&nbsp;0-50KM/H</div>
                        </div>
                    </div>

                    <div className="evc1_two_info_t_wrap">
                        <div className="evc1_two_info_t1">최대 토크</div>
                        <div className="evc1_two_info_t1_val_wrap">
                            <div className="evc1_two_info_t1_val">26/205</div>
                            <div className="evc1_two_info_t1_unit_1">Nm</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="evc1_three">
                <img className="evc1_three_image_pc" src={IMG_3_1} alt="내연과 전기의 경계를 허무는 끝없는 출력" />
                <img className="evc1_three_image_pad" src={IMG_3_2} alt="내연과 전기의 경계를 허무는 끝없는 출력" />
                <img className="evc1_three_image_mobile" src={IMG_3_3} alt="내연과 전기의 경계를 허무는 끝없는 출력" />

                <div className="evc1_three_t_wrap">
                    <div className="evc1_three_t1">Endless Limits</div>
                    <div className="evc1_three_t2">
                        내연과 전기의 경계를
                        <br />
                        허무는 끝없는 출력
                    </div>
                    <div className="evc1_three_t3 pc_pad">
                        EV-C1의 강력한 파워트레인은 최대 7.2kW의 출력으로 경사가 있는
                        <br />
                        언덕 위에서나 다이내믹한 도로 위에서도 밀리지 않는 성능을 발휘합니다.
                    </div>
                    <div className="evc1_three_t3 mobile">
                        EV-C1의 강력한 파워트레인은
                        <br />
                        최대 7.2kW의 출력으로 경사가 있는
                        <br />
                        언덕 위에서나 다이내믹한 도로 위에서도
                        <br />
                        밀리지 않는 성능을 발휘합니다.
                    </div>
                </div>

                <div className="evc1_three_swiper_wrapper">
                    <div className="evc1_three_swiper_t1">FEATURES</div>
                    <div className="swiper-outer">
                        <ScooterEvC1SwiperOne />
                        <div className="evc1_three_swiper_btn_wrap">
                            <button className="evc1_three_swiper_btn slide-control-btn prev">
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_PC}
                                    className="evc1_three_swiper_btn_img pc prev"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_PAD}
                                    className="evc1_three_swiper_btn_img pad prev"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_MOBILE}
                                    className="evc1_three_swiper_btn_img mobile prev"
                                    alt="left"
                                />
                            </button>
                            <button className="evc1_three_swiper_btn slide-control-btn next">
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_PC}
                                    className="evc1_three_swiper_btn_img pc next"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_PAD}
                                    className="evc1_three_swiper_btn_img pad next"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_MOBILE}
                                    className="evc1_three_swiper_btn_img mobile next"
                                    alt="right"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="evc1_four">
                <div className="evc1_four_t_wrap">
                    <div className="evc1_four_t_1">
                        더 편안한 시트포지션
                        <br />더 강력한 파워트레인
                    </div>
                    <div className="evc1_four_t_2 pc_pad">
                        높은 수준의 기술력을 바탕으로 제작된 특수한 시트와 안전한 차체 제어 장치는
                        <br />
                        주행 중 피로감을 줄이고 또 다른 승차감을 제공합니다.
                    </div>
                    <div className="evc1_four_t_2 mobile">
                        높은 수준의 기술력을 바탕으로 제작된 특수한
                        <br />
                        시트와 안전한 차체 제어 장치는 주행 중<br />
                        피로감을 줄이고 또 다른 승차감을 제공합니다.
                    </div>
                </div>

                <div className="evc1_four_swiper_wrapper">
                    <div className="swiper-outer">
                        <ScooterEvC1SwiperTwo />
                        <div className="evc1_four_swiper_btn_wrap">
                            <button className="evc1_four_swiper_btn slide-control-btn prev">
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_PC}
                                    className="evc1_four_swiper_btn_img pc"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_PAD}
                                    className="evc1_four_swiper_btn_img pad"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_MOBILE}
                                    className="evc1_four_swiper_btn_img mobile"
                                    alt="left"
                                />
                            </button>
                            <button className="evc1_four_swiper_btn slide-control-btn next">
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_PC}
                                    className="evc1_four_swiper_btn_img pc"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_PAD}
                                    className="evc1_four_swiper_btn_img pad"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_MOBILE}
                                    className="evc1_four_swiper_btn_img mobile"
                                    alt="right"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* 더욱 간편해진 편의기능 */}
            <div className="evc1_five">
                <div className="evc1_five_t_wrap">
                    <div className="evc1_five_t_1">더욱 간편해진 편의기능</div>
                    <div className="evc1_five_t_2 pc_pad">
                        실용성까지 갖춘 전기스쿠터를 완성하기 위해 크루징 발판,
                        <br />
                        전면 및 하단 수납공간, 충전 소켓 등 편의성을 더 한 장치를 추가하였습니다.
                    </div>
                    <div className="evc1_five_t_2 mobile">
                        실용성까지 갖춘 전기스쿠터를 완성하기 위해
                        <br />
                        크루징 발판, 전면 및 하단 수납공간, 충전 소켓 등<br />
                        편의성을 더 한 장치를 추가하였습니다.
                    </div>
                </div>

                <div className="evc1_five_swiper_wrapper">
                    <div className="evc1_five_swiper_t1">FEATURES</div>
                    <div className="swiper-outer">
                        <ScooterEvC1SwiperThree />

                        <div className="evc1_five_swiper_btn_wrap">
                            <button className="evc1_five_swiper_btn slide-control-btn prev">
                                <img
                                    src={IMG_SLIDER_LEFT_BLACK_PC}
                                    className="evc1_five_swiper_btn_img pc"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_PAD}
                                    className="evc1_five_swiper_btn_img pad"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_WHITE_MOBILE}
                                    className="evc1_five_swiper_btn_img mobile"
                                    alt="left"
                                />
                            </button>
                            <button className="evc1_five_swiper_btn slide-control-btn next">
                                <img
                                    src={IMG_SLIDER_RIGHT_BLACK_PC}
                                    className="evc1_five_swiper_btn_img pc"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_PAD}
                                    className="evc1_five_swiper_btn_img pad"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_WHITE_MOBILE}
                                    className="evc1_five_swiper_btn_img mobile"
                                    alt="right"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="evc1_six">
                <img className="evc1_six_image_pc" src={IMG_6_1} alt="크록세라 6.0으로 달라지는 주행 경험" />
                <img className="evc1_six_image_pad" src={IMG_6_2} alt="크록세라 6.0으로 달라지는 주행 경험" />
                <img className="evc1_six_image_mobile" src={IMG_6_3} alt="크록세라 6.0으로 달라지는 주행 경험" />

                <div className="evc1_six_t_wrap">
                    <div className="evc1_six_t1">Always Connected.</div>
                    <div className="evc1_six_t2">
                        크록세라 6.0으로
                        <br />
                        달라지는 주행 경험
                    </div>
                </div>
            </div>
            <div className="evc1_seven">
                <img className="evc1_seven_image_pc" src={IMG_7_1} alt="FULL LCD 디스플레이로 더 크고 환하게" />
                <img className="evc1_seven_image_pad" src={IMG_7_2} alt="FULL LCD 디스플레이로 더 크고 환하게" />
                <img className="evc1_seven_image_mobile" src={IMG_7_3} alt="FULL LCD 디스플레이로 더 크고 환하게" />

                <div className="evc1_seven_t_wrap">
                    <div className="evc1_seven_t1">
                        FULL LCD 디스플레이로
                        <br />더 크고 환하게
                    </div>
                    <div className="evc1_seven_t2_wrap">
                        <div className="evc1_seven_t2">5.0 인치 TFT LCD</div>
                        <div className="evc1_seven_t2">24 bit 풀컬러 디스플레이</div>
                    </div>
                </div>
            </div>
            {/* 앱하나로 관리하는 스마트커넥티드 서비스 */}
            <div className="evc1_eight">
                <div className="evc1_eight_t_wrap">
                    <div className="evc1_eight_t1">
                        앱 하나로 관리하는
                        <br />
                        스마트 커넥티드 서비스
                    </div>
                </div>
                <div className="evc1_eight_swiper_wrapper">
                    <div className="swiper-outer">
                        <ScooterEvC1SwiperFour />
                        <div className="evc1_eight_swiper_btn_wrap">
                            <button className="evc1_eight_swiper_btn slide-control-btn prev">
                                <img
                                    src={IMG_SLIDER_LEFT_BLACK_PC}
                                    className="evc1_eight_swiper_btn_img pc"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_BLACK_PAD}
                                    className="evc1_eight_swiper_btn_img pad"
                                    alt="left"
                                />
                                <img
                                    src={IMG_SLIDER_LEFT_BLACK_MOBILE}
                                    className="evc1_eight_swiper_btn_img mobile"
                                    alt="left"
                                />
                            </button>
                            <button className="evc1_eight_swiper_btn slide-control-btn next">
                                <img
                                    src={IMG_SLIDER_RIGHT_BLACK_PC}
                                    className="evc1_eight_swiper_btn_img pc"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_BLACK_PAD}
                                    className="evc1_eight_swiper_btn_img pad"
                                    alt="right"
                                />
                                <img
                                    src={IMG_SLIDER_RIGHT_BLACK_MOBILE}
                                    className="evc1_eight_swiper_btn_img mobile"
                                    alt="right"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="evc1_nine">
                <img
                    className="evc1_nine_image_pc"
                    src={IMG_9_1}
                    alt="지속적인 소프트웨어 업데이트로 주행을 늘 새롭게 만듭니다."
                />
                <img
                    className="evc1_nine_image_pad"
                    src={IMG_9_2}
                    alt="지속적인 소프트웨어 업데이트로 주행을 늘 새롭게 만듭니다."
                />
                <img
                    className="evc1_nine_image_mobile"
                    src={IMG_9_3}
                    alt="지속적인 소프트웨어 업데이트로 주행을 늘 새롭게 만듭니다."
                />

                <div className="evc1_nine_t_wrap">
                    <div className="evc1_nine_t1 pc_pad">
                        지속적인 소프트웨어 업데이트로
                        <br />
                        주행을 늘 새롭게 만듭니다.
                    </div>
                    <div className="evc1_nine_t1 mobile">
                        지속적인 소프트웨어 <br />
                        업데이트로 주행을 <br />늘 새롭게 만듭니다.
                    </div>
                    <div className="evc1_nine_t2_wrap">
                        <div className="evc1_nine_t2">
                            어플리케이션
                            <br />
                            업데이트
                        </div>
                        <div className="evc1_nine_t2">
                            펌웨어
                            <br />
                            업데이트
                        </div>
                    </div>
                </div>
            </div>
            <div className="evc1_ten">
                <div className="evc1_ten_swiper_wrapper">
                    <div className="swiper-outer">
                        <button className="evc1_ten_swiper_btn slide-control-btn prev">
                            <img src={IMG_SLIDER_LEFT_BLACK_PC} className="evc1_ten_swiper_btn_img  pc" alt="left" />
                            <img src={IMG_SLIDER_LEFT_BLACK_PAD} className="evc1_ten_swiper_btn_img  pad" alt="left" />
                            <img
                                src={IMG_SLIDER_LEFT_BLACK_MOBILE}
                                className="evc1_ten_swiper_btn_img  mobile"
                                alt="left"
                            />
                        </button>
                        <ScooterEvC1SwiperFive />
                        <button className="evc1_ten_swiper_btn slide-control-btn next">
                            <img src={IMG_SLIDER_RIGHT_BLACK_PC} className="evc1_ten_swiper_btn_img pc" alt="right" />
                            <img
                                src={IMG_SLIDER_RIGHT_BLACK_PAD}
                                className="evc1_ten_swiper_btn_img  pad"
                                alt="right"
                            />
                            <img
                                src={IMG_SLIDER_RIGHT_BLACK_MOBILE}
                                className="evc1_ten_swiper_btn_img  mobile"
                                alt="right"
                            />
                        </button>
                    </div>
                </div>
                <div className="evc1_ten_bike_name">EV-C1</div>
                <div className="evc1_ten_bike_desc">한계를 뛰어넘는 특별함</div>
                <div className="evc1_ten_bike_color_wrap">
                    <div className="evc1_ten_bike_color_white"></div>
                    <div className="evc1_ten_bike_colo_gray"></div>
                    <div className="evc1_ten_bike_color_black"></div>
                </div>
                <div className="evc1_ten_detail_t1_wrap pc_pad">
                    <div className="evc1_ten_detail_t1">디테일</div>
                    <hr className="evc1_ten_detail_hr" />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="25%" />
                            <col width="60%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td rowSpan={5} className="evc1_ten_detail_table_td_title vertical_align_top">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.SCOOTER_SPECIFI_TEXT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.COLOR_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.COLOR}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.SIZE_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.SIZE}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.WEIGHT_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.WEIGHT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.TRUNK_CAPACITY_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.TRUNK_CAPACITY}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <hr className="evc1_ten_detail_hr" />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="25%" />
                            <col width="60%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td rowSpan={7} className="evc1_ten_detail_table_td_title vertical_align_top">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.BASIC_SPECIFI_TEXT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_OUTPUT_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_OUTPUT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_TORQUE_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_TORQUE}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.ABILITY_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.ABILITY}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_MILE_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_MILE}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.DRIVING_MODE_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.DRIVING_MODE}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.REVERSE_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.BASIC_SPECIFI.REVERSE}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <hr className="evc1_ten_detail_hr" />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="25%" />
                            <col width="60%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td rowSpan={8} className="evc1_ten_detail_table_td_title vertical_align_top">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.SAFETY_SPECIFI_TEXT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.LOCK_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.LOCK}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.REAR_SHOCK_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.REAR_SHOCK}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_SYSTEAM_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_SYSTEAM}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_CALIPER_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_CALIPER}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.HEADLIGHT_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.HEADLIGHT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TAILLIGHT_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TAILLIGHT}
                                </td>
                            </tr>
                            <tr>
                                <td className="evc1_ten_detail_table_td_title">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TURN_SIGNAL_TEXT}
                                </td>
                                <td className="evc1_ten_detail_table_td_content">
                                    {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TURN_SIGNAL}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <hr className="evc1_ten_detail_hr last_hr" />
                </div>

                <div className="evc1_ten_detail_t1_wrap mobile">
                    {/* 차체제원 */}
                    <div className="evc1_ten_detail_table_td_title">
                        {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.SCOOTER_SPECIFI_TEXT}
                    </div>
                    <div className="evc1_ten_detail_table">
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.COLOR_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.COLOR}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.SIZE_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.SIZE}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.WEIGHT_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.WEIGHT}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.TRUNK_CAPACITY_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SCOOTER_SPECIFI.TRUNK_CAPACITY}
                            </div>
                        </div>
                    </div>
                    {/* 기본제원 */}
                    <div className="evc1_ten_detail_table_td_title">
                        {EVC1_SCOOTER_INFO.BASIC_SPECIFI.BASIC_SPECIFI_TEXT}
                    </div>
                    <div className="evc1_ten_detail_table">
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_OUTPUT_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_OUTPUT}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_TORQUE_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_TORQUE}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.ABILITY_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.ABILITY}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_MILE_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.MAX_MILE}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.DRIVING_MODE_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.DRIVING_MODE}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.REVERSE_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.BASIC_SPECIFI.REVERSE}
                            </div>
                        </div>
                    </div>
                    {/* 안전기능 */}
                    <div className="evc1_ten_detail_table_td_title">
                        {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.SAFETY_SPECIFI_TEXT}
                    </div>
                    <div className="evc1_ten_detail_table">
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.LOCK_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.LOCK}
                            </div>
                        </div>

                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.REAR_SHOCK_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.REAR_SHOCK}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_SYSTEAM_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_SYSTEAM}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_CALIPER_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.BRAKE_CALIPER}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.HEADLIGHT_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.HEADLIGHT}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TAILLIGHT_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TAILLIGHT}
                            </div>
                        </div>
                        <div className="evc1_ten_detail_table_td_wrap">
                            <div className="evc1_ten_detail_table_td_subtitle">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TURN_SIGNAL_TEXT}
                            </div>
                            <div className="evc1_ten_detail_table_td_content">
                                {EVC1_SCOOTER_INFO.SAFETY_SPECIFI.TURN_SIGNAL}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="evc1_ten_detail_desc">
                    *스마트 스쿠터 모델 별로 액세서리 구매가 가능합니다. 정부 법규에 따라 해당 액세서리의 적법성이
                    변동될 수 있으며 액세서리를 구매함으로써 구매자는 이러한 위험을 감수할 것을 명시적으로 인정하고 이에
                    동의하는 것으로 간주됩니다.
                    <br />
                    *완충 배터리 최대 주행 가능 거리: 경사 0%의 아스팔트 도로에서 화창한 날 63kg의 라이더가 테스트 수행
                    <br />
                    *최대 속도: 경사 0%의 아스팔트 도로에서 스포츠 모드와 슈퍼 부스트 모드를 켜고 주행
                    <br />
                    *등판 능력: 아스팔트 도로에서 63kg의 라이더가 테스트 수행
                    <br />
                    *전면 수납공간을 제공하는 스쿠터 모델의 경우, 전면 수납공간은 방수 기능을 지원하지 않으며 300g을
                    초과하는 물품을 수납할 수 없습니다.
                    <br />
                    *상기 제원과 기능은 성능 향상을 위해 예고없이 변경될 수 있습니다. 성능, 테스트 결과 또는 거리와
                    관련된 모든 데이터는 참고용일 뿐이며 다른 요인에 따라 달라질 수 있습니다.
                </div>
            </div>
        </div>
    )
}

export default ScooterEvC1
